/**
 * Viewport width (px) below which tooltips flip to their mobile placement.
 *
 * Shared so the tooltip components can't drift apart: `InfoTooltip` uses it to
 * choose left vs right, and `VisibilityScore` to choose left vs top.
 */
export const TOOLTIP_MOBILE_MAX_WIDTH = 800;
